import { SiteMap } from './types'

export const CLARAVINE_TEXT = 'Claravine'

export const getSiteMap = (DATASETS_PAGE_ENABLED: boolean): SiteMap => ({
  auth: {
    login: 'Login',
  },
  datasets: 'Datasets',
  codes: {
    templates: 'Templates',
    submissions: 'Submissions',
    pending: 'Pending',
    search: 'Search',
    approval: 'Approval Requests',
    details: {
      data: 'Data',
      history: 'History',
    },
    create: 'New Draft',
    update: 'Edit Draft',
  },
  template: {
    data: 'Data',
    submissions: 'Submissions',
    integrations: 'Integrations',
    pending: 'Pending',
  },
  reports: DATASETS_PAGE_ENABLED ? 'Dataset Explorer' : 'Template Explorer',
  admin: {
    account: {
      reports: 'Settings - Reports',
      settings: 'Settings - Account Settings',
    },
    settings: 'My Profile',
    users: 'Settings - Users',
    groups: 'Settings - Groups',
    accounts: 'Settings - Accounts',
    targets: 'Settings - Targets',
    patterns: {
      root: 'Settings - Patterns',
      new: 'New Pattern',
    },
    lists: {
      root: 'Settings - Lists',
      edit: {
        root: 'Edit List',
        new: 'New List',
      },
    },
    fieldsets: {
      root: 'Settings - Fieldsets',
      new: {
        fields: 'New Fieldset',
      },
    },
    templates: {
      root: 'Settings - Templates',
      'edit-template': {
        setup: 'Setup',
        govern: 'Govern',
        connect: 'Connect',
        new: {
          setup: 'New Template - Setup',
          govern: 'New Template - Govern',
          connect: 'New Template - Connect',
        },
      },
    },
    folders: 'Settings - Folders',
  },
})
